/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_News_HeadingInputs */

const ja_playdata_home_news_heading = /** @type {(inputs: Playdata_Home_News_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お知らせ`)
};

const en_playdata_home_news_heading = /** @type {(inputs: Playdata_Home_News_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News`)
};

/**
* | output |
* | --- |
* | "News" |
*
* @param {Playdata_Home_News_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_news_heading = /** @type {((inputs?: Playdata_Home_News_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_News_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_news_heading(inputs)
	return en_playdata_home_news_heading(inputs)
});